export type MsgType = "SMS" | "LMS" | "MMS";
export type ScheduleStatus = "scheduled" | "sending" | "cancelled";

export interface ScheduleRecipient {
  name?: string;
  phone: string;
}

export interface ScheduleItem {
  id: string;
  type: MsgType;
  subject?: string;
  message: string;
  hasImage?: boolean;
  recipients: ScheduleRecipient[];
  senderNumber: string;
  status: ScheduleStatus;
  scheduledAt: string;
  createdAt: string;
  cost: number;
}

export const STATUS_CONFIG: Record<ScheduleStatus, { label: string; className: string; dotClass: string; icon: string }> = {
  scheduled: {
    label: "예약 대기",
    className: "bg-violet-500/15 text-violet-400 border border-violet-500/20",
    dotClass: "bg-violet-400",
    icon: "ri-calendar-schedule-line",
  },
  sending: {
    label: "발송 중",
    className: "bg-amber-500/15 text-amber-400 border border-amber-500/20",
    dotClass: "bg-amber-400",
    icon: "ri-loader-4-line",
  },
  cancelled: {
    label: "취소됨",
    className: "bg-gray-500/15 text-gray-400 border border-gray-500/20",
    dotClass: "bg-gray-400",
    icon: "ri-close-circle-line",
  },
};

export const TYPE_CONFIG: Record<MsgType, { className: string; price: number }> = {
  SMS: { className: "bg-violet-500/20 text-violet-300", price: 20 },
  LMS: { className: "bg-pink-500/20 text-pink-300", price: 50 },
  MMS: { className: "bg-amber-500/20 text-amber-300", price: 100 },
};

// DB 레코드를 ScheduleItem으로 변환
export function mapDbToScheduleItem(record: any): ScheduleItem {
  const fmtDate = (iso: string | null) => {
    if (!iso) return "";
    const d = new Date(iso);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${y}.${m}.${day} ${hh}:${mm}`;
  };

  return {
    id: record.id,
    type: (record.type as MsgType) || "SMS",
    subject: record.subject || undefined,
    message: record.message || "",
    hasImage: record.has_image || false,
    recipients: (record.send_recipients || []).map((r: any) => ({
      name: r.name || undefined,
      phone: r.phone || "",
    })),
    senderNumber: record.sender_number || "",
    status: (record.status as ScheduleStatus) || "scheduled",
    scheduledAt: fmtDate(record.scheduled_at),
    createdAt: fmtDate(record.created_at),
    cost: record.cost || 0,
  };
}